<template>
  <div style="display: flex;height: 100%;">
    <div class="left">
      <img src="../../assets/phone.png" alt="">
      <div style="position:relative;">
        <img :src="img.url">
        <template v-for="(val,key) in img.item">
          <div :key="key" :style="{'left':val.x_axis+'%','top':val.y_axis+'%','position': 'absolute',}"
               class="point">{{val.is_show==1 ? val.title : ''}}</div>
        </template>
      </div>
    </div>
    <div class="right">
      <!--        <vue-upload is-server  v-model="img.url" ></vue-upload>-->
      <div class="mt-10 mb-10" style="display: flex;">
        <div class="upload" @click="is_img=true">
<!--          <vue-upload v-model="img.url" max-size="5000" style="display: inline-block;margin-right: 10px;" accept="image/*"></vue-upload>
          <div style="font-size: 13px;text-align: center;margin-right: 10px;color: #999">点击图片更换</div>-->
          <img :src="img.url">
        </div>
        <div style="flex:1">
            <el-button size="small" @click="audio" type="primary" >上传解说音频</el-button>
            <el-button type="primary" size="small" @click="addpoint" >添加锚点</el-button>
            <div slot="tip" class="el-upload__tip" v-if="img['audio']">
              <el-tag type="success" class="mr-10" size="small">{{ choose.filename }}</el-tag>
              <el-popconfirm title="确定删除？" @confirm="del_audio()">
                <el-button slot="reference" type="danger" size="mini" >删除</el-button>
              </el-popconfirm>
            </div>
            <div slot="tip" class="el-upload__tip ">只能上传音频文件，且不超过1000kb</div>
        </div>
      </div>
      <div style="height:450px;overflow: auto;padding: 10px 0;">
        <template v-for="(val,key) in img.item">
          <div :key="key" class="point_list">
            <div class="iconfont icon-close-circle" @click="del(key)"></div>
            <el-form label-width="90px">
              <el-form-item label="类型" prop="">
                <template>
                  <el-radio-group v-model="val.type">
                    <el-radio label="text">文本</el-radio>
                    <el-radio label="video">视频</el-radio>
                    <el-radio label="category">目录链接</el-radio>
                    <el-radio label="page">单页链接</el-radio>
                    <el-radio label="ebook">电子书链接</el-radio>
                  </el-radio-group>
                </template>
              </el-form-item>
              <el-form-item label="位置" prop="">
                <el-radio v-model="val.is_show" label="1">默认</el-radio>
                <el-radio v-model="val.is_show" label="2">透明区域</el-radio>
                <el-input v-model="val.x_axis" placeholder="%" style="width: 140px;margin-right: 10px;" type="number"
                          min='0' max='100'><template slot="prepend">距左</template></el-input>
                <el-input v-model="val.y_axis" placeholder="%" style="width: 140px;" type="number" min='0'
                          max='100'><template slot="prepend">距上
                </template></el-input>
              </el-form-item>
              <el-form-item label="标题" prop="" v-if="val.is_show==1">
                <el-input v-model="val.title" placeholder="标题"
                          style="width: 200px;margin-right: 10px;" ></el-input>
              </el-form-item>
              <el-form-item label="文本" prop="" v-if="val.type=='text'">
                <f-edit v-model="val.text" :isServer="false" :width="480"></f-edit>
              </el-form-item>
              <el-form-item label="单页链接" prop="" v-if="val.type=='page'">
                <el-select v-model="val.page_sort_id" clearable filterable placeholder="搜索选择分类" class="w-200 mr-20" @change="select_sort($event,key)">
                  <el-option
                      v-for="it in sort_list"
                      :key="it.id"
                      :label="it.title"
                      :value="it.id">
                  </el-option>
                </el-select>
                <el-select v-model="val.page_id" filterable  placeholder="搜索选择单页">
                  <el-option
                      v-for="it in page_list"
                      :key="it.id"
                      :label="it.title"
                      :value="it.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电子书链接" prop="" v-if="val.type=='ebook'">
                <el-select v-model="val.ebook_id" filterable  placeholder="搜索选择电子书">
                  <el-option
                      v-for="it in ebook_list"
                      :key="it.id"
                      :label="it.title"
                      :value="it.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="目录链接" prop="" v-if="val.type=='category'">
                <el-select v-model="val.catagory_id" filterable placeholder="搜索选择目录">
                  <template v-for="(it,k) in content">
                    <el-option
                        :key="k"
                        :label="it.title ? it.title : '目录名称'"
                        :value="k" >
<!--                      v-if="it.title && index!=k"-->
                    </el-option>
                  </template>
                </el-select>
                <span class="ml-10">建议自定义目录名称</span>
              </el-form-item>
              <el-form-item label="视频" prop="video" v-if="val.type=='video'">
                <div style="border: 1px solid #ccc;border-radius: 5px;display: inline-block;" @click="video(key)">
                  <video v-if="val.video" :src="val.video" class="avatar"></video>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </div>
    </div>
    <layer-pop title="选择音视频" @close="is_media=false" v-if="is_media">
      <upload-list @submit="media_choose"></upload-list>
    </layer-pop>
    <layer-pop title="选择图片" @close="is_img=false" v-if="is_img">
      <upload-img @submit="img_choose"></upload-img>
    </layer-pop>
  </div>
</template>

<script>
import FEdit from '@/components/form/f-edit'
import LayerPop from "@/components/layer-pop.vue";
import UploadList from "@/components/upload/upload-list.vue";
import UploadImg from "@/components/upload/upload-img.vue";
export default {
name: "edit",
components:{UploadImg, UploadList, LayerPop,FEdit},
  props:{
    img : {type : Object, default : function (){return {}}},
    content:{type:[String,Array],default:''},
    index:{type : [String,Number], default:''}
  },
  data(){
    return{
      rules : {
        title : [{required:true, message : '请填写', trigger:'blur'}],
        type : [{required:true, message : '请填写', trigger:'blur'}],
      },
      page_list:[],
      ebook_list:[],
      dir : [],
      sort_list:[],
      sort_id:'',
      is_media:false,
      is_img:false,
      choose:'',
      upload_type:'',
      k:''
    }
  },
  mounted:async function() {
    try {
      let uid = this.user.uid;
      if (uid){
        await this.get_sort_list();
        await this.get_list(uid);
      }
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    get_list:async function(uid){
      try {
        let query = this.$route.query;
        let id = query.id ? query.id : 0;
        let res = await this.$_api.page('list', {uid : uid,page_id:id});
        if (res.errcode == 0){
          console.log(res.list);
          this.page_list = res.list;
        }
        let rs = await this.$_api.ebook('list', {uid : uid,page_id:id});
        if (rs.errcode == 0){
          this.ebook_list = rs.list;
        }
      }catch (e) {
        console.log(e);
      }
    },
    get_sort_list:async function (){
      let res = await this.$_api.page('sort_list', {size:100,uid:this.user.uid});
      if(res.errcode == 0){
        this.sort_list = res.list;
      }
    },
    select_sort:async function (e,key){
      console.log(e);
      let query = this.$route.query;
      let id = query.id ? query.id : 0;
      let uid = this.user.uid;
      let sort_id = e;
      let res = await this.$_api.page('list', {uid : uid,sort_id:sort_id,page_id:id});
      if (res.errcode == 0){
        console.log(res.list);
        this.page_list = res.list;
      }else{
        this.page_list = [];
        this.img.item[key].page_id = '';
      }
    },
    addpoint:function (){
      let item =
          {type:'text',title:'',is_show:'1',x_axis:'0',y_axis:'0',ebook:'',ebook_id:'',category:'',catagory_id:'',video:'',content:'',page:'',page_id:'',page_sort_id:''};
      this.img.item.push(item);
    },
    del:async function (key){
      let res =await this.$_confirm('确认删除？','删除',);
      if(res){
        this.img.item.splice(key,1);
      }
    },
    video:function (k){
      this.upload_type = 'video';
      this.is_media = true;
      this.k = k;
    },
    audio:function (){
      this.upload_type = 'audio';
      this.is_media = true;
    },
    media_choose:function (e){
      if(this.upload_type == 'audio'){
        this.img['audio'] = e.url;
      }else{
        this.img.item[this.k].video = e.url;
      }
      this.choose = e;
      this.is_media = false;
    },
    img_choose:function (e){
      this.img.url = e.url;
      this.is_img = false;
    },
    del_audio:function (){
      this.img['audio'] = '';
    },
  }
}
</script>

<style scoped>
.point{
  position:absolute;
  padding:2px 6px;
  background:rgba(38,34,33,.3);
  border-radius:20px;
  font-size:12px;
  color:#ffffff;
  z-index:99;
  transform:translateX(8px)translateY(-50%);
}
.point::after{
  left:-12px;
  content:"";
  display:block;
  position:absolute;
  width:8px;
  height:8px;
  border-radius:50%;
  background:rgba(0,0,0,.2);
  top:50%;
  transform:translateY(-50%);
}
.point_list{
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
  border-radius: 5px;
  position: relative;
}
.icon-close-circle{
  color: #dd524d;
  position: absolute;
  right: -2px;
  top:-10px;
  font-size: 26px;
  z-index: 999;
  cursor: pointer;
}
.left{
  width: 500px;
  background: #f6f8f9;
  padding: 2px;
  margin-right: 20px;
  /*overflow: auto;*/
}
.left img{width: 100%;}
.right{
  flex:1;
  padding: 10px 0;
}
.avatar-uploader  {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 150px;
  height: 150px;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.upload {
  width: 120px;
  height: 140px;
  line-height: 140px;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
.upload img {
  width: 100%;
  height: 100%;
  object-fit: contain
}
</style>